import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTask({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1a1 1 0 00-1 1v1a1 1 0 001 1h4a1 1 0 001-1V2a1 1 0 00-1-1H6zM3.25 4a.25.25 0 01.25-.25H4a.75.75 0 000-1.5h-.5A1.75 1.75 0 001.75 4v9c0 .966.784 1.75 1.75 1.75h9A1.75 1.75 0 0014.25 13V4a1.75 1.75 0 00-1.75-1.75H12a.75.75 0 000 1.5h.5a.25.25 0 01.25.25v9a.25.25 0 01-.25.25h-9a.25.25 0 01-.25-.25V4zm7.25 3h-5a.75.75 0 010-1.5h5a.75.75 0 010 1.5zm-5 3h3a.75.75 0 000-1.5h-3a.75.75 0 000 1.5z"
      />
    </svg>
  );
}

SvgBasicTask.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTask.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicTask svgRef={ref} {...props} />);
export default ForwardRef;
